import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'fi',
    debug: true,
    keySeparator: '.',
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    ns: [
      'translation',
      'mainActivityCodeDesc',
      'pollutantName',
      'pollutantAbbreviation',
      'pollutantCasNumber'
    ] // load these namespaces already on init
  })

export default i18n
